import { render, staticRenderFns } from "./FortuneWheelDialog.vue?vue&type=template&id=e3ecb186&"
import script from "./FortuneWheelDialog.vue?vue&type=script&lang=js&"
export * from "./FortuneWheelDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports